import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';

export const FIELDS_NAME = {
  NEW_STATE: 'newState',
} as const;

export const initialValues = {
  [FIELDS_NAME.NEW_STATE]: '',
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.NEW_STATE]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
});
